import DebouncedInput from '@/shared/components/debounced-input'
import { FilterPopover } from '@/shared/components/filter-popover'
import { AccreditationSelector, CompanySelector, ContractSelector, EmployeeRoleSelector, StatusSelector } from '@/shared/selectors'
import { Button } from '@material-tailwind/react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { FiSearch } from 'react-icons/fi'
import { useSearchParams } from 'react-router-dom'

export const EmployeeFilter = () => {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()

  const FILTER_KEYS = Object.freeze({
    contractId: 'contract_id',
    companyId: 'company_id',
    q: 'q',
    roleId: 'role_id',
    accredited: 'accredited',
    status: 'status'
  })

  const MUTUALLY_EXCLUSIVE_FILTERS = Object.freeze({
    [FILTER_KEYS.contractId]: FILTER_KEYS.companyId,
    [FILTER_KEYS.companyId]: FILTER_KEYS.contractId
  })

  const handleFilterChange = (name, value) => {
    if (value === '' || value === null || value === undefined) {
      searchParams.delete(name)
    } else {
      const filterToClear = MUTUALLY_EXCLUSIVE_FILTERS[name]
      if (filterToClear) searchParams.delete(filterToClear)

      searchParams.set(name, value)
      searchParams.set('page', 1)
    }
    setSearchParams(searchParams)
  }

  const handleInputSearch = (value) => {
    handleFilterChange(FILTER_KEYS.q, value)
  }

  const removeQueries = () => {
    Object.values(FILTER_KEYS).forEach((filterKey) =>
      searchParams.delete(filterKey)
    )

    setSearchParams(searchParams)
  }

  return (
    <div className='flex gap gap-3'>
      <div>
        <DebouncedInput
          name={FILTER_KEYS.q}
          icon={<FiSearch />}
          label={t('employee.searcher.label')}
          onChange={handleInputSearch}
          value={searchParams.get(FILTER_KEYS.q) || ''}
          className='w-full sm:w-80'
        />
      </div>
      <FilterPopover>
        <div className='grid gap gap-4'>
          <div className='grid gap gap-2'>
            <EmployeeRoleSelector
              value={Number(searchParams.get(FILTER_KEYS.roleId))}
              onChange={(option) =>
                handleFilterChange(FILTER_KEYS.roleId, option?.value)
              }
            />
          </div>
          <div className='grid gap gap-2'>
            <ContractSelector
              value={Number(searchParams.get(FILTER_KEYS.contractId))}
              onChange={(option) =>
                handleFilterChange(FILTER_KEYS.contractId, option?.value)
              }
            />
          </div>
          <div className='grid gap gap-2'>
            <CompanySelector
              label={t('contractor.one')}
              value={Number(searchParams.get(FILTER_KEYS.companyId))}
              onChange={(option) =>
                handleFilterChange(FILTER_KEYS.companyId, option?.value)
              }
            />
          </div>
          <div className='grid gap gap-2'>
            <AccreditationSelector
              value={searchParams.get(FILTER_KEYS.accredited)}
              onChange={(option) =>
                handleFilterChange(FILTER_KEYS.accredited, option?.value)
              }
            />
          </div>
          <div className='grid gap gap-2'>
            <StatusSelector
              value={searchParams.get(FILTER_KEYS.status)}
              onChange={(option) =>
                handleFilterChange(FILTER_KEYS.status, option?.value)
              }
            />
          </div>
        </div>

        <div className='flex justify-center mt-10'>
          <Button
            type='button'
            className='bg-color-white text-red-600 border-solid border-2 border-red-200 p-2'
            onClick={removeQueries}
          >
            {t('filters.delete')}
          </Button>
        </div>
      </FilterPopover>
    </div>
  )
}

EmployeeFilter.propTypes = {
  open: PropTypes.bool,
  handler: PropTypes.func
}
